import Api from '@/api/api'
export default {
    getMenu() {
        return Api.get('/api/menu/GetSuperAdminMenu')
        // return Api.get('org/Api/Menu')
    },
    getSettingMenu() {
        return Api.get('/api/Settings/GetAllTenantsForSuperAdmin')
    }
}